<template>
  <div class="com-table">
    <div class="com-table-wrapper">
      <div class="table-header">
        <div
          class="table-cell"
          v-for="(item, index) in tableCol"
          :key="index"
          :style="{
            // 'flex-basic': cell.width ? `${cell.width}px` : '',
            'min-width': item.width ? `${item.width}px` : '',
            'max-width': item.maxWidth ? `${item.maxWidth}px` : '',
          }"
          :align="item.align ? item.align : 'center'"
          :label="item.label"
          :prop="item.param"
        >
          <span>
            {{ item.label }}
          </span>
        </div>
      </div>
      <!-- <vue-seamless-scroll></vue-seamless-scroll> -->
      <div class="table-body">
        <div class="table-row" v-if="tableData.length === 0">
          <div class="table-cell" @click="cell.fn(item)" :align="'center'">
            <span>暂无数据</span>
          </div>
        </div>
        <div
          class="table-row"
          v-for="(item, index) in tableData"
          :key="index"
          :align="item.align ? item.align : 'center'"
        >
          <div
            :class="'table-cell ' + (cell.fn ? 'isLink' : '')"
            v-for="(cell, jndex) in tableCol"
            :key="jndex"
            :style="{
              // 'flex-basic': cell.width ? `${cell.width}px` : '',
              'min-width': cell.width ? `${cell.width}px` : '',
              'max-width': cell.maxWidth ? `${cell.maxWidth}px` : '',
            }"
            @click="cell.fn(item)"
            :align="cell.align ? cell.align : 'center'"
          >
            <span v-if="cell.type === 'index'">
              {{ (pager.currentPage - 1) * 10 + index + 1 }}
            </span>
            <span v-else>{{
              /^.{0}$/g.test(item[cell.param]) || item[cell.param] == null || item[cell.param] == undefined
                ? '--'
                : item[cell.param]
            }}</span>
          </div>
          <!--<template slot-scope="scope">-->
          <!--  &lt;!&ndash; 判空tableData &ndash;&gt;-->
          <!--  &lt;!&ndash; <span-->
          <!--    v-if="/^.{0}$/g.test(scope.row[item.param])"-->
          <!--    v-text="'&#45;&#45;'"-->
          <!--  ></span> &ndash;&gt;-->
          <!--  &lt;!&ndash; 显示tableData &ndash;&gt;-->
          <!--  &lt;!&ndash; <span v-else>{{ scope.row[item.param] }}</span> &ndash;&gt;-->

          <!--  &lt;!&ndash; render自定义更多内容 &ndash;&gt;-->
          <!--  <render-slot-->
          <!--    v-if="item.render"-->
          <!--    :render="item.render"-->
          <!--    :row="scope.row"-->
          <!--    :index="scope.$index"-->
          <!--    :column="item"-->
          <!--  />-->
          <!--  &lt;!&ndash; slot插槽更多内容 &ndash;&gt;-->
          <!--  <template v-for="itemslot of slotList" v-else-if="item.slot">-->
          <!--    <slot-->
          <!--      :name="itemslot.slot"-->
          <!--      :index="scope.$index"-->
          <!--      :prop="item.param"-->
          <!--    ></slot>-->
          <!--  </template>-->
          <!--  &lt;!&ndash; 正常内容 &ndash;&gt;-->
          <!--  &lt;!&ndash;          scope.row[item.param] == [] ||&ndash;&gt;-->
          <!--  <span v-else>{{-->
          <!--    /^.{0}$/g.test(tableData[index].row[item.param]) ||-->
          <!--    tableData[index].row[item.param] == null ||-->
          <!--    tableData[index].row[item.param] == undefined-->
          <!--      ? "&#45;&#45;"-->
          <!--      : tableData[index].row[item.param]-->
          <!--  }}</span>-->
          <!--</template>-->
        </div>
      </div>
    </div>
    <ElePage
      ref="ElePage"
      v-bind="$attrs"
      v-if="isPagination"
      :pager="pages"
      :position="position"
      :pageSizes="pageSizes ? pageSizes : [10, 20, 30, 40]"
      @paginationSize="handleSizeChange"
      @paginationCurrent="handleCurrentChange"
    />
  </div>
</template>

<script>
import vueSeamless from 'vue-seamless-scroll';
export default {
  name: 'ComTable',
  props: {
    tableData: {
      // 表格数据
      type: Array,
      default: () => {
        return [];
      },
    },
    tableCol: {
      // 列信息
      type: Array,
      default: () => {
        return [];
      },
    },
    pager: {
      // 分页信息
      type: Object,
      default: function () {
        return {
          currentPage: 1,
          pageSize: 10,
          total: 0,
        };
      },
    },
    // 位置
    position: {
      type: String,
      default: 'right',
    },
    // 页数的数组
    pageSizes: {
      type: Array,
    },
    isPagination: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      pages: this.pager,
    };
  },
  mounted() {
    let _this = this;
    _this.$bus.$on('refreshPageNum', () => {
      _this.pages.currentPage = 1;
    });
  },
  watch: {
    'pager.total'(n) {
      console.log(n);
    },
  },
  methods: {
    // 分页table置顶
    scrollTop() {
      this.$nextTick(() => {
        let el = this.$el.querySelector('.el-table__body-wrapper');
        el && (el.scrollTop = 0);
      });
    },
    // size发生变化时，并发送自定义事件
    handleSizeChange(val) {
      this.$emit('handleSizeChange', val);
      this.scrollTop();
    },
    // currentPage发生变化时，发送自定义事件
    handleCurrentChange(val) {
      this.$emit('handleCurrentChange', val);
      this.scrollTop();
    },
  },
  computed: {
    // 获取slotList列表
    slotList() {
      return (
        this.$attrs &&
        this.$attrs.slotList.filter((col) => {
          return col.slot;
        })
      );
    },
  },
};
</script>

<style lang="less" scoped>
.com-table {
  width: 100%;
  height: 100%;

  .com-table-wrapper {
    height: calc(100% - 60px);
    overflow: hidden;
    margin-bottom: 10px;
  }

  .table-header {
    width: 100%;
    height: 55px;
    background: linear-gradient(0deg, #236197, #152f4b);
    border-radius: 5px 5px 0 0;
    display: flex;
    align-items: center;

    .table-cell {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
  }

  .table-body {
    height: calc(100% - 60px);
    .show-scroll();
  }

  .table-cell {
    flex: 1;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fff;
    padding: 0 10px;
    &.isLink {
      cursor: pointer;
      font-weight: bold;
      color: #5ed6ff;
    }
  }

  .table-row {
    min-height: 50px;
    margin: 4px 0;
    border: 1px solid #5ed6ff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    position: relative;
    padding: 5px 0;

    &::before {
      content: '';
      width: calc(100% + 4px);
      height: 6px;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
      position: absolute;
      top: -2px;
      left: -3px;
      border-radius: 4px 26px 8px 4px;
    }
  }

  .ele-page {
    height: 50px;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    /deep/ .el-pagination {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-style: italic;
      color: #b8b8b8;
      line-height: 35px;
      .el-pagination__total {
        color: #b8b8b8;
        height: 20px;
        line-height: 20px;
        margin-right: 22px;
      }
      .btn-prev,
      .btn-next {
        width: 20px;
        height: 20px;
        min-width: auto;
        background: linear-gradient(
          0deg,
          rgba(0, 197, 250, 0.5) 0%,
          rgba(0, 197, 250, 0.48) 6%,
          rgba(0, 197, 250, 0.11) 100%
        );
        border-radius: 50%;
        border: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        i {
          width: 0;
          height: 0;
          display: inline-block;
          border: 5px solid transparent;
          &::before {
            display: none;
          }
        }
      }
      .btn-prev {
        i {
          border-right-color: #87e6ff;
          margin-left: -5px;
        }
      }
      .btn-next {
        i {
          border-left-color: #87e6ff;
          margin-right: -5px;
        }
      }
      .el-pager {
        height: 20px;
        li {
          border: none;
          height: 20px;
          line-height: 20px;
        }
      }
      .el-pagination__jump {
        color: #b8b8b8;
        height: 20px;
        line-height: 20px;

        .el-input__inner {
          width: 35px;
          height: 24px;
          background: linear-gradient(
            0deg,
            rgba(0, 197, 250, 0.5) 0%,
            rgba(0, 197, 250, 0.48) 6%,
            rgba(0, 197, 250, 0.11) 100%
          );
          border-radius: 3px;
          border: none;
        }
      }
    }
  }
}
</style>
